<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/87Yalp/tc-custom/9781398408487.jpg?1705766067513" alt="This image is the cover for the book Thirteen Months of Sunshine"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thirteen Months of Sunshine
      </h1>
      <p class="bookDescription body article font2">
        <p>Ethiopians have not completely put that historical famine – of ‘Live Aid’ times – behind them and they struggle to understand or to keep up with the Western world, including their ever-advancing technology. Education there is seen as a key to success but balancing developments alongside embedded tribal and superstitious beliefs is not easy. At least now schools have moved from drawing in the dust under a shady tree, into purpose-built structures – with or without resources. <br/>It was into this environment Valerie was placed when, following the dramatic changes in her circumstances, she made her momentous decision to put her comfortable English life on hold and to replace it with a year in that developing country. At 58, not only did she use her life skills and teaching experience in the northern town of Mekelle, but she lived through a potentially dangerous political time. Valerie used in-country transport to visit some amazing places which included her medal-winning run in Addis Ababa! Partly to record every little detail but also to maintain some sort of sanity, she kept a detailed diary throughout that roller coaster year. This book gives the reader a combination of an entertaining personal read of diaried key events, alongside her own Ethiopian life with its water conservation, frugal diet, wind, dust and much more. Valerie records an honest and sometimes harrowing insight into the little-known everyday existence of Ethiopians.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Valerie McKee
      </h2>
      
      <p class="authorDescription body article">Following her family split, Valerie McKee decided to pursue a dream of volunteering in a third world country. Once she took retirement from her prestigious job in a renowned public Cambridge school, she gained a place with Voluntary Services Overseas as a teaching advisor in northern Ethiopia. <br>This candid autobiography records the highs and the many lows of that extraordinary year, during which, she aimed not just to survive but to be an effective volunteer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3dca7486